<template>
  <div>
    <a-row>
      <a-col :span="16" :lg="16" :sm="24" :xs="24">
        <a-card style="margin: 10px 20px 10px 20px; padding: 10px">
          <keyword-chart ref="keywordChart"></keyword-chart>
        </a-card>
      </a-col>

      <a-col :span="8" :lg="8" :sm="24" :xs="24">
        <a-card style="margin: 10px 20px 10px 0; padding: 10px">
          <keywordPieChart ref="keywordPieChart"></keywordPieChart>
        </a-card>
      </a-col>
    </a-row>
    <a-row>
      
    </a-row>

    <a-row style="width: 100%">
      <a-col :span="24">
        <keyword-flu-info
          ref="keywordFluInfo"
          style="margin: 10px 20px 10px 20px; padding: 20px"
        ></keyword-flu-info>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  keywordChart,
  keywordPieChart,
  KeywordFluInfo,
} from "./components/index.js";
import { getChartByKeyWord } from "@/api/charts.js";
import { getKeyWordFluByKeyWord } from "@/api/keyword.js";
export default {
  components: {
    keywordChart,
    keywordPieChart,
    KeywordFluInfo,
  },
  data() {
    return {
      receivedId: null,
      KeyWord: "",
      KeywordWciData: [],
      TypeData: [],
      TypeWciData:[],
      KeywordTkData: [],
      TypeTkData:[],
      FluData: [],
    };
  },
  created() {
    this.receivedId = this.$route.query.id || null;
    this.GetDate();
  },
  methods: {
    GetDate() {
      getChartByKeyWord(this.receivedId).then((res) => {
        if (res.code == 0) {
          this.KeywordWciData = res.data.kwWciInfo;
          this.TypeData = res.data.typeList;
          this.TypeWciData = res.data.typeWciInfo;
          this.KeywordTkData = res.data.kwTkInfo;
          this.TypeTkData = res.data.typeTkInfo;
          
          this.$nextTick(() => {
            this.$refs["keywordChart"].SetData(
              this.KeywordWciData,
              this.TypeData,
              this.TypeWciData,
              this.KeywordTkData,
              this.TypeTkData
            );
            this.$refs["keywordPieChart"].SetData(this.KeywordWciData, this.KeywordTkData);
            this.$refs["keywordFluInfo"].SetData(this.KeywordWciData);
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      getKeyWordFluByKeyWord(this.receivedId).then((res) => {
        if (res.code == 0) {
          this.FluData = res.data;
          this.$nextTick(() => {
            this.$refs["keywordFluInfo"].SetFluData(res.data);
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>